import Badge from './badge';
import BadgeAnchor from './badge-anchor';
Badge.Anchor = BadgeAnchor;
export default Badge;